import { createApi } from '@reduxjs/toolkit/query/react';

import rtkFetchRequest from '../configs/rtkFetchRequest';

// Define a service using a base URL and expected endpoints
export const addressesApi = createApi({
  reducerPath: 'addresses',
  baseQuery: rtkFetchRequest(),
  endpoints: (builder) => ({
    getAddressById: builder.query({
      query: (id) => ({
        method: 'GET',
        endpoint: `/addresses/${id}`,
      }),
    }),
    getAddresses: builder.query({
      query: () => ({
        method: 'GET',
        endpoint: `/addresses/`,
      }),
    }),
    updateAdress: builder.mutation({
      query: ({ id, query, ...params }) => ({
        method: 'PATCH',
        endpoint: `/addresses/${id}`,
        body: params,
      }),
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetAddressByIdQuery,
  useGetAddressesQuery,
  useUpdateAdressMutation,
} = addressesApi;
